// import { cloneDeep } from 'lodash'
import Api from '@api'

const state = {
  currentPicture: 0
}

const getters = {
  getCurrentPicture: state => state.currentPicture
}

const mutations = {
  UPDATE_CURRENT_PICTURE: (state, number) => {
    state.currentPicture = number
  }
}

const actions = {
  async fetchGetCommon ({ dispatch }) {
    const response = await Api.getCommonContent()
    dispatch('header/updateItems', response.header.menu.items, { root: true })
    dispatch('footer/updateEmail', response.footer.email, { root: true })
  },
  updateCurrentPicture: ({ commit }, index) => {
    commit('UPDATE_CURRENT_PICTURE', index)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
